
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^([036]|26)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
